import { useEffect, useState } from 'react';

export function OverrideCountdown({ expiresAt }: { expiresAt: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const ms = Math.max(0, Date.parse(expiresAt) - now);
  const minutes = Math.floor(ms / 60_000);
  const seconds = Math.floor((ms % 60_000) / 1000);
  if (ms === 0) return <span className="muted">expired</span>;
  return <span className="tabular">{minutes}m {seconds.toString().padStart(2, '0')}s</span>;
}
